export function groupArrayByPrefix(arr, prefixDelimiter) {
    if (!Array.isArray(arr)) {
        return null;
    }

    return Object.values(
        arr.reduce((ret, val) => {
            let prefix = val.split(prefixDelimiter).shift();

            if (!ret[prefix]) {
                ret[prefix] = [];
            }

            ret[prefix].push(val);

            return ret;
        }, {})
    );
}
